<div class="section-header" mat-dialog-title>
    <mat-icon class="section-icon">swap_horiz</mat-icon>
    <span class="section-title">{{ 'ai.confirmComponentSwitch' | transloco }}</span>
    <button mat-icon-button class="ss-dialog-close-btn" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<div mat-dialog-content>
    <p class="confirmation-message">
        {{ 'ai.switchConfirmationMessage' | transloco: {
            from: ('ai.' + data.fromComponent.toLowerCase() | transloco),
            to: ('ai.' + data.toComponent.toLowerCase() | transloco)
        } }}
    </p>
    <div class="switch-info">
        <div class="component-item from">
            <mat-icon>{{ data.fromComponent === 'Collection' ? 'collections' : 'playlist_play' }}</mat-icon>
            <span>{{ ('ai.' + data.fromComponent.toLowerCase()) | transloco }}</span>
        </div>
        <mat-icon class="arrow">arrow_forward</mat-icon>
        <div class="component-item to">
            <mat-icon>{{ data.toComponent === 'Collection' ? 'collections' : 'playlist_play' }}</mat-icon>
            <span>{{ ('ai.' + data.toComponent.toLowerCase()) | transloco }}</span>
        </div>
    </div>
    <div class="warning-note">
        <mat-icon>warning</mat-icon>
        <span>{{ 'ai.switchWarning' | transloco }}</span>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">
        {{ 'ai.cancel' | transloco }}
    </button>
    <button mat-raised-button color="primary" (click)="onConfirm()">
        {{ 'ai.confirm' | transloco }}
    </button>
</div>